const navigationFr = {
    "menu_editor": "Menu",
    "settings": "Paramètres",
    "payment_settings": "Paramètres de paiement",
    "user_management": "Gestion des utilisateurs",
    "logout": "Déconnexion",
    "subscription": "Abonnement",
    "new_restaurant": "Créer un nouveau restaurant",
    "privacy_policy": "politique de confidentialité",
    "terms_and_conditions": "Termes et conditions",
    "statistics": "Statistiques",
    "mozrest": "Gestionnaire de révision",
    "signup": "S'inscrire"
};

export default navigationFr;
